import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/leasehistory/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Add_data_modal from "../../components/leasehistory/update_data_modal";
import LeaseHistoryDetailModal from "../../components/leasehistory/LeaseHistory Details";
import Layouts from "../../layouts/layouts";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
} from "@fortawesome/free-solid-svg-icons";
import Switch from "react-switch";

export default function LeaseHistory() {
  const title = "Lease History Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);
  const userRole = localStorage.getItem("userRole");
  const [lockedSwitches, setLockedSwitches] = useState({
    paymentPaid: new Set(),
  });
  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [customMonth, setCustomMonth] = useState("");
  const [customYear, setCustomYear] = useState("");
  const [showGenerateBtn, setShowGenerateBtn] = useState(false);

  const [update_modal_data, setUpdate_modal_data] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [showLeasehistoryDetailModal, setShowLeasehistoryDetailModal] =
    useState(false);
  const [selectedLeaseHistory, setSelectedLeaseHistory] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const columns = [
    {
      name: <b>Vehicles</b>,
      cell: (row) => {
        const vehicles =
          (Array.isArray(row.id_vehicle) &&
            row.id_vehicle.map((vehicle) => vehicle.numberplate)) ||
          [];

        return (
          <div style={{ position: "relative", zIndex: 1 }}>
            {vehicles.length > 0 ? (
              vehicles.map((numberplate, index) => (
                <p key={index} style={{ margin: "0" }}>
                  {numberplate}
                </p>
              ))
            ) : (
              <p style={{ margin: "0" }}>-</p>
            )}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: <b>Year / Month </b>,
      selector: (row) => `${row.year} / ${String(row.month).padStart(2, "0")}`,
      sortable: true,
    },
    {
      name: <b> Leasing Partner</b>,
      selector: (row) => (row.id_lease ? row.id_lease.leasing_partner : "N/A"),
      sortable: true,
    },
    {
      name: <b> Leasing Amount</b>,
      selector: (row) => (row.id_lease ? row.id_lease.leasing_amount : "N/A"),
      sortable: true,
    },
    {
      name: <b>Total Leasing</b>,
      selector: (row) => {
        const leasingAmount = row.id_lease?.leasing_amount || 0;
        const vehicleCount = Array.isArray(row.id_vehicle)
          ? row.id_vehicle.length
          : 0;
        return leasingAmount * vehicleCount;
      },
      sortable: true,
    },
    {
      name: <b>Actual Amount</b>,
      selector: (row) => row.actualAmount || "-",
      sortable: true,
    },
    {
      name: <b>Remaining Amount</b>,
      selector: (row) => row.remainingAmount || "-",
      sortable: true,
    },

    {
      name: <b>Payment Done</b>,
      selector: (row) => (row.paymentPaid ? "True" : "False"),
      cell: (row) => (
        <Switch
          onChange={() => handleToggleSwitch(row, "paymentPaid")}
          checked={row.paymentPaid}
          disabled={lockedSwitches.paymentPaid.has(row._id) || row.paymentPaid}
        />
      ),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {/* View button (Accessible to both Superadmin & Admin) */}
          <button
            onClick={() => viewLeasehistory(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const updateLeasehistory = (updatedLeasehistory) => {
    setApiState((prev) =>
      prev.map((leasehistory) =>
        leasehistory._id === updatedLeasehistory._id
          ? updatedLeasehistory
          : leasehistory
      )
    );
  };
  const handleFetchCustomData = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "No token found", "error");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/list?month=${customMonth}&year=${customYear}`,
        { headers }
      );

      if (Array.isArray(response.data.data) && response.data.data.length > 0) {
        setApiState(response.data.data);
        setApiCol(columns);
        setShowGenerateBtn(false);
      } else {
        Swal.fire({
          title: "Data Not Found",
          text: "Data is not present. Please generate Lease.",
          icon: "warning",
        });
        setShowGenerateBtn(true);
      }
    } catch (error) {
      console.error("Fetch Error:", error);
      Swal.fire("Error", "Unable to fetch data", "error");
      setShowGenerateBtn(true);
    }
  };
  const handleGenerateLeasehistory = async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      Swal.fire("Error", "No token found", "error");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    try {
      await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/sync?month=${customMonth}&year=${customYear}`,
        {},
        { headers }
      );

      Swal.fire("Success", "Lease generated successfully", "success");
      handleFetchCustomData(); // Fetch again after generation
    } catch (error) {
      console.error("Generation Error:", error);
      Swal.fire("Error", "Lease generation failed", "error");
    }
  };

  const fetchData = async (page) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    // Step 1: Calculate previous month and year
    const currentDate = new Date();
    currentDate.setMonth(currentDate.getMonth() - 1);
    const prevMonth = currentDate.getMonth() + 1; // getMonth() is 0-based
    const prevYear = currentDate.getFullYear();

    try {
      // Step 2: Try to fetch previous month's data
      const prevResponse = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/list?month=${prevMonth}&year=${prevYear}`,
        { headers }
      );

      if (
        Array.isArray(prevResponse.data.data) &&
        prevResponse.data.data.length > 0
      ) {
        setApiState(prevResponse.data.data);
        setApiCol(columns);
        return;
      }

      // Step 3: Fetch all data to find latest available month/year
      const allResponse = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/list`,
        { headers }
      );

      const allLeasehistory = allResponse.data.data || [];
      if (allLeasehistory.length === 0) {
        setApiState([]);
        return;
      }

      // Step 4: Find the latest month and year from available data
      const sorted = allLeasehistory.sort((a, b) => {
        const dateA = new Date(a.year, a.month - 1);
        const dateB = new Date(b.year, b.month - 1);
        return dateB - dateA;
      });

      const latest = sorted[0];
      const latestMonth = latest.month;
      const latestYear = latest.year;

      // Step 5: Fetch data for latest month/year
      const latestResponse = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/list?month=${latestMonth}&year=${latestYear}`,
        { headers }
      );

      setApiState(latestResponse.data.data || []);
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const handleToggleSwitch = async (leasehistory, field) => {
    const fieldDateMap = {
      paymentPaid: "paymentPaidDate",
    };

    const friendlyLabel = {
      paymentPaid: "Payment Sent",
    };

    if (leasehistory[field]) return; // Prevent switching off

    // Today's date in YYYY-MM-DD format
    const today = new Date().toISOString().split("T")[0];

    const { value: inputDate } = await Swal.fire({
      title: `<div style="font-size: 22px; font-weight: 600; color: #4A00E0;">
              ${friendlyLabel[field]} Confirmation
            </div>`,
      html: `
      <div style="margin-top: 15px; font-size: 16px; color: #444;">
        Please select a date for <strong>${friendlyLabel[field]}</strong>:
      </div>
      <input 
        type="date" 
        id="date-input" 
        class="swal2-input"
        style="margin-top: 10px; font-size: 16px; padding: 8px;"
        max="${today}" 
      />
    `,
      showCancelButton: true,
      confirmButtonText: "✔️ Update",
      cancelButtonText: "❌ Cancel",
      focusConfirm: false,
      customClass: {
        popup: "swal2-shadow swal2-rounded",
        confirmButton: "swal2-confirm-btn",
        cancelButton: "swal2-cancel-btn",
      },
      preConfirm: () => {
        const dateVal = document.getElementById("date-input").value;
        if (!dateVal) {
          Swal.showValidationMessage("📅 Please select a valid date.");
        }
        return dateVal;
      },
    });

    if (!inputDate) return;

    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token");

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      };

      const payload = {
        [field]: true,
        [fieldDateMap[field]]: inputDate,
      };

      await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/v4/lease-history/update?leaseHistoryId=${leasehistory._id}`,
        { updateData: payload }, // wrap the payload inside `updateData`
        { headers }
      );

      setApiState((prev) =>
        prev.map((item) =>
          item._id === leasehistory._id ? { ...item, ...payload } : item
        )
      );

      setLockedSwitches((prev) => {
        const updated = new Set(prev[field]);
        updated.add(leasehistory._id);
        return { ...prev, [field]: updated };
      });

      Swal.fire({
        icon: "success",
        title: "✅ Updated Successfully!",
        text: `${friendlyLabel[field]} status and date saved.`,
        confirmButtonColor: "#4CAF50",
      });
    } catch (error) {
      Swal.fire("Error!", `Failed to update ${friendlyLabel[field]}.`, "error");
      console.error(`Update error for ${field}:`, error);
    }
  };

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const updatedLeasehistory = (updatedLeasehistory) => {
    setApiState((prev) =>
      prev.map((leasehistory) =>
        leasehistory._id === updatedLeasehistory._id
          ? updatedLeasehistory
          : leasehistory
      )
    );
  };

  const viewLeasehistory = (leasehistory) => {
    setSelectedLeaseHistory(leasehistory);
    setShowLeasehistoryDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((leasehistory) => {
      const leasingPartner = leasehistory.id_lease?.leasing_partner || "N/A";
      const leaseStatus = leasehistory.id_lease?.status || "N/A";
      const onboardingDate = leasehistory.id_lease?.onboardingDate
        ? new Date(leasehistory.id_lease.onboardingDate).toLocaleDateString()
        : "N/A";
      const leasingAmount = leasehistory.id_lease?.leasing_amount || 0;

      const vehiclePlates = Array.isArray(leasehistory.id_vehicle)
        ? leasehistory.id_vehicle.map((v) => v.numberplate).join(", ")
        : "N/A";

      const totalLeasing =
        leasingAmount * (leasehistory.id_vehicle?.length || 0);

      return {
        "Leasing Partner": leasingPartner,
        "Lease Status": leaseStatus,
        "Onboarding Date": onboardingDate,
        "Leasing Amount (Per Vehicle)": leasingAmount,
        "Number of Vehicles": leasehistory.id_vehicle?.length || 0,
        "Vehicle Numberplates": vehiclePlates,
        "Total Leasing": totalLeasing,
        Month: leasehistory.month,
        Year: leasehistory.year,
        "Payment Paid": leasehistory.paymentPaid ? "Yes" : "No",
        "Created At": new Date(leasehistory.createdAt).toLocaleString(),
        "Updated At": new Date(leasehistory.updatedAt).toLocaleString(),
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "LeaseHistory");

    XLSX.writeFile(workbook, "leasehistory.xlsx");
  };

  const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onupdateLeasehistory={updatedLeasehistory}
      />
      <LeaseHistoryDetailModal
        show={showLeasehistoryDetailModal}
        onHide={() => setShowLeasehistoryDetailModal(false)}
        leasehistory={selectedLeaseHistory}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm me-2"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="d-flex flex-wrap align-items-end gap-2 px-4 pt-3">
                <div className="d-flex gap-2">
                  <div>
                    <select
                      className="form-select"
                      value={customMonth}
                      onChange={(e) => setCustomMonth(parseInt(e.target.value))}
                    >
                      <option value="">Select Month</option>
                      {months.map((m) => (
                        <option key={m.value} value={m.value}>
                          {m.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <select
                      className="form-select"
                      value={customYear}
                      onChange={(e) => setCustomYear(parseInt(e.target.value))}
                    >
                      <option value="">Select Year</option>
                      {years.map((y) => (
                        <option key={y} value={y}>
                          {y}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="d-flex gap-2 align-items-center">
                  <button
                    className="btn btn-primary mt-2"
                    onClick={handleFetchCustomData}
                    disabled={!customMonth || !customYear}
                  >
                    <FontAwesomeIcon icon={faEye} className="me-1" />
                    Fetch Lease Data
                  </button>

                  {showGenerateBtn && (
                    <button
                      className="btn btn-warning mt-2"
                      onClick={handleGenerateLeasehistory}
                    >
                      <FontAwesomeIcon icon={faPenToSquare} className="me-1" />
                      Generate Lease
                    </button>
                  )}
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="vehicle"
                    title_btn={true}
                    apidata={apistate}
                    // columns={apicol}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
